import { DashboardNavigation } from './DashboardNavigation'

export default DashboardNavigation
